// START_MODULE routes_route_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
export const route = {
  base: '/',
  news: '/news',
  newsDetails: (newsId = ':newsId') => `/news/${newsId}`,
};

// END_MODULE routes_route_ts
